import { Injectable } from '@angular/core';
import { environment } from '@environment';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { SnackBarService } from './snack-bar.service';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private hubConnection: signalR.HubConnection;
  public transactionCompleted$ = new Subject<any>();

  constructor(
    public _snackBarService: SnackBarService,
    public _sharedService: SharedService
  ) {}

  public startConnection(token: string, practiceId: number): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.tenantNotificationHubUrl, {
        accessTokenFactory: () => token,
      })
      .build();

    this.hubConnection
      .start()
      .then(() => {
        console.log('SignalR Connection started');
        this.listenForMessages();
        this.joinUserGroup(practiceId);
      })
      .catch((err) =>
        console.log('Error while starting SignalR connection: ' + err)
      );

    this.hubConnection.onreconnecting(() => {
      console.log('SignalR reconnecting...');
    });

    this.hubConnection.onreconnected(() => {
      console.log('SignalR reconnected');
    });
  }

  public joinUserGroup(practiceId: number) {
    this.hubConnection
      .invoke('JoinUserGroup', practiceId)
      .then(() => {
        console.log(`Joined group for practice ID: ${practiceId}`);
      })
      .catch((err) => console.error('Error joining group:', err));
  }

  public triggerOnDemandExtraction(practiceId: number) {
    this.hubConnection
      .invoke('TriggerOnDemandExtraction', practiceId)
      .then(() => {
        console.log(
          `Triggered On Demand Extraction for practice ID: ${practiceId}`
        );
      })
      .catch((err) =>
        console.error('Error triggering on demand extraction:', err)
      );
  }

  public triggerPmsConfigurationChanged(practiceId: number) {
    this.hubConnection
      .invoke('PmsConfigurationChanged', practiceId)
      .then(() => {
        console.log(
          `Triggered Pms Configured changed for practice ID: ${practiceId}`
        );
      })
      .catch((err) =>
        console.error('Error triggering on Pms Configuration Change:', err)
      );
  }

  listenForMessages() {
    this.hubConnection.on('WriteBackCompleted', (data) => {
      console.log('Received transaction writeback notification:', data);
      this._snackBarService.openSnackBar(
        `${data.message?.toString()} : TransactionId : ${data.transactionId?.toString()}`,
        'Success'
      );
    });

    this.hubConnection.on('WriteBackFailed', (data) => {
      console.log(
        'Received transaction writeback notification for Fail:',
        data
      );
      this._snackBarService.openSnackBar(data.message, 'Error');
    });

    this.hubConnection.on('OnDemandSyncRequestReceived', (data) => {
      console.log('Received On Demand Sync Request notification:', data);
      //this._snackBarService.openSnackBar(data.message, 'Success');
    });

    this.hubConnection.on('OnDemandSyncStarted', (data) => {
      console.log('Started On Demand Sync notification:', data);
      this._snackBarService.openSnackBar(data.message, 'Success');
    });

    this.hubConnection.on('PmsExtractionCompleted', (data) => {
      console.log('Received PMS extraction notification:', data);
      this._snackBarService.openSnackBar(data.message, 'Success');
    });

    this.hubConnection.on('DataLoaderCompleted', (data) => {
      console.log('Received Data Loader notification:', data);
      this._snackBarService.openSnackBar(data.message, 'Success');
    });

    this.hubConnection.on('OnDemandSyncStatus', (data) => {
      console.log('Received On Demand Sync Status notification:', data);
      this._sharedService.setOnDemandSyncStatus(data.isOnDemandSuccessful);
    });

    this.hubConnection.on('InstallerInstalled', (data) => {
      console.log('Received Installer Installed notification:', data);
      this._sharedService.setIsInstallerInstalled(true);
    });

    this.hubConnection.on('PmsConfigurationChanged', () => {
      console.log('Received Pms Configuration Changed notification');
      this._sharedService.setIsPmsConfigurationchanged(true);
    });
  }

  public stopConnection(): void {
    this.hubConnection
      .stop()
      .then(() => console.log('SignalR Connection stopped'))
      .catch((err) =>
        console.log('Error while stopping SignalR connection: ' + err)
      );
  }
}
